module.exports = __webpack_public_path__ + "static/media/bg11.470feb01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg11.jpg
// module id = 5771
// module chunks = 0